import * as React from 'react';
import { Avatar, Box } from '@mui/material';
import { useRecordContext } from 'react-admin';

const FullNameField = ({ source = 'username' }) => {
  const record = useRecordContext();
  return record ? (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
      }}
    >
      <Avatar
        src={
          record.avatar
            ? `${record.avatar}?${Math.random()}&size=${25}x${25}`
            : null
        }
        style={{ width: 25, height: 25, marginRight: '12px' }}
      />
      {source ? record[source] : record.username}
    </Box>
  ) : null;
};

export default React.memo(FullNameField);
